// extracted by mini-css-extract-plugin
export default {"container":"Zk","header":"al","logodesktop":"bl","logomobile":"cl","imgcontainer":"el","slidercontainer":"fl","slick-slider":"gl","slick-initialized":"hl","sliderbox":"il","headline":"jl","mainheadline":"kl","capitalize":"ll","desc":"ml","descitalic":"nl","desccenter":"ol","descborder":"pl","subdesc":"ql","welcomeslide":"rl","desccard":"sl","img":"tl","button":"ul","buttonskip":"vl","customPosition":"wl"};
    if(module.hot) {
      // 1738836196003
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  